export default "__VITE_ASSET__DJi1arRI__"